var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',[_c('v-card',{attrs:{"height":"82vh"}},[_c('iframe',{ref:"pdf",staticStyle:{"width":"100%","height":"100%"},attrs:{"frameBorder":"0","src":_vm.src}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }